import { createContext, useContext, useEffect } from "react";
import { divisionMeta } from "@/lib/constants";

const DivisionContext = createContext(null);

// Single-division CRM — everything is Univicoustic.
export function DivisionProvider({ children }) {
  useEffect(() => {
    const meta = divisionMeta("univicoustic");
    const root = document.documentElement;
    root.style.setProperty("--division-primary", meta.primary);
    root.style.setProperty("--division-soft", meta.soft);
    root.style.setProperty("--division-text", meta.text);
  }, []);

  const value = {
    division: "univicoustic",
    setDivision: () => {},
    isGlobal: false,
    divisionParam: undefined, // server scopes by the user's division
  };

  return <DivisionContext.Provider value={value}>{children}</DivisionContext.Provider>;
}

export const useDivision = () => useContext(DivisionContext);
